import {
  useMemo,
  useState
} from "react";

import "./CriarCategoriaBanner.css";

function CriarCategoriaBanner({
  categorias,
  onClose,
  onSalvar
}) {
  const [busca, setBusca] =
    useState("");

  const [
    mostrarOpcoes,
    setMostrarOpcoes
  ] = useState(false);

  const [
    grupoSelecionado,
    setGrupoSelecionado
  ] = useState(null);

  const [arquivo, setArquivo] =
    useState(null);

  const [preview, setPreview] =
    useState(null);

  const [salvando, setSalvando] =
    useState(false);

  const categoriasFiltradas =
    useMemo(() => {
      const texto =
        busca.toLowerCase();

      return categorias.filter(
        (categoria) =>
          categoria.descricao
            ?.toLowerCase()
            .includes(texto) ||
          String(
            categoria.codgrupo
          ).includes(texto)
      );
    }, [busca, categorias]);

  const handleSelecionarImagem =
    (e) => {
      const file =
        e.target.files?.[0];

      if (!file) return;

      setArquivo(file);

      const reader =
        new FileReader();

      reader.onload =
        (event) => {
          setPreview(
            event.target.result
          );
        };

      reader.readAsDataURL(file);
    };

  const handleSalvar =
    async () => {
      if (!grupoSelecionado) {
        alert(
          "Selecione uma categoria."
        );
        return;
      }

      if (!arquivo) {
        alert(
          "Selecione uma imagem."
        );
        return;
      }

      try {
        setSalvando(true);

        const formData =
          new FormData();

        formData.append(
          "imagem",
          arquivo
        );

        const uploadResponse =
          await fetch(
            "https://app.eliandroalimentos.com.br/api/imagem/upload",
            {
              method: "POST",
              body: formData,
            }
          );

        const uploadData =
          await uploadResponse.json();

        if (
          !uploadResponse.ok
        ) {
          throw new Error(
            uploadData.message ||
              "Erro ao fazer upload"
          );
        }

        const response =
          await fetch(
            "https://app.eliandroalimentos.com.br/api/home_media/criarbanner",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
              },
              body: JSON.stringify({
                imagem:
                  uploadData.caminho,
                localizacao:
                  "categoriabanner",
                ordem:
                  grupoSelecionado.codgrupo,
              }),
            }
          );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data.message ||
              "Erro ao criar banner"
          );
        }

        onSalvar?.();

      } catch (error) {
        console.error(error);

        alert(
          error.message ||
            "Erro ao salvar"
        );
      } finally {
        setSalvando(false);
      }
    };

  return (
    <div
      className="criarCategoriaBanner-overlay"
      onClick={onClose}
    >
      <div
        className="criarCategoriaBanner-container"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="criarCategoriaBanner-header">

          <h2>
            Novo Banner de Categoria (2126 × 591 px) .jpg
          </h2>

          <button
            className="criarCategoriaBanner-fechar"
            onClick={onClose}
          >
            ✕
          </button>

        </div>

        <div className="criarCategoriaBanner-autocomplete">

          <input
            type="text"
            placeholder="Buscar categoria..."
            value={busca}
            onChange={(e) => {
              setBusca(
                e.target.value
              );

              setMostrarOpcoes(
                true
              );

              setGrupoSelecionado(
                null
              );
            }}
            onFocus={() => {
              if (
                busca.trim()
              ) {
                setMostrarOpcoes(
                  true
                );
              }
            }}
          />

          {mostrarOpcoes &&
            busca.trim() &&
            categoriasFiltradas.length >
              0 && (
              <div className="criarCategoriaBanner-dropdown">

                {categoriasFiltradas.map(
                  (
                    categoria
                  ) => (
                    <div
                      key={
                        categoria.codgrupo
                      }
                      className="criarCategoriaBanner-dropdownItem"
                      onClick={() => {
                        setGrupoSelecionado(
                          categoria
                        );

                        setBusca(
                          `${categoria.codgrupo} - ${categoria.descricao}`
                        );

                        setMostrarOpcoes(
                          false
                        );
                      }}
                    >
                      {
                        categoria.codgrupo
                      }
                      {" - "}
                      {
                        categoria.descricao
                      }
                    </div>
                  )
                )}

              </div>
            )}

        </div>

        <input
          type="file"
          accept="image/*"
          onChange={
            handleSelecionarImagem
          }
        />

        {preview && (
          <>
            <div className="criarCategoriaBanner-previewOriginal">

              <img
                src={preview}
                alt=""
              />

            </div>

            <div className="criarCategoriaBanner-previewSite">

              <img
                src={preview}
                alt=""
              />

            </div>
          </>
        )}

        <div className="criarCategoriaBanner-footer">

          <button
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            onClick={
              handleSalvar
            }
            disabled={
              salvando
            }
          >
            {salvando
              ? "Salvando..."
              : "Salvar"}
          </button>

        </div>

      </div>
    </div>
  );
}

export default CriarCategoriaBanner;